<template>
    <PageHeader>
        <template #header>
            <h4>{{ $t(`${messagesApplyMode}.congratulations`) }}</h4>
            <ul class="mt-6 pl-2">
                <li v-for="offer in providerOffersList" :key="offer.key" class="header-list-item">
                    {{ offer.offerMessage }}: {{ offer.approvalAmount | currencyWhole }}
                </li>
            </ul>
        </template>
    </PageHeader>
</template>

<script>
    import { applicationState, providerState } from "@/state"
    import { getMessagesApplyMode } from "@/model/apply/ApplyMode"

    import Providers from "@/model/provider/Providers"
    import DynamicProviderKey from "@/model/provider/DynamicProviderKey"
    import ProviderKey from "@/model/provider/ProviderKey"
    import ProductType from "@/model/provider/ProductType"

    export default {
        name: "PaymentPlanHeader",
        props: {
            responses: {
                type: Array,
                required: true,
            },
        },
        computed: {
            messagesApplyMode() {
                return getMessagesApplyMode(applicationState.applyMode)
            },

            providerOffersList() {
                const offers = []
                this.responses.forEach(response => {
                    const dynamicKey = DynamicProviderKey.extractProviderKey(response.providerKey)
                    const provider = Providers[dynamicKey]
                    const productType = providerState.getPaymentPlans(response.providerKey)[0]?.typeId
                    const offerMessage =
                        productType && provider.fundingSourceDescriptionByProductType
                            ? provider.fundingSourceDescriptionByProductType[productType.toLowerCase()]
                            : provider.fundingSourceDescription
                              ? provider.fundingSourceDescription
                              : provider.fundingName
                    const paymentPlans = providerState.responses[response.providerKey]?.paymentPlans || []

                    const hasSynchronyLoanPlans =
                        response.providerKey.includes(ProviderKey.SYNCHRONY_STANDARD) &&
                        paymentPlans.some(plan => plan.providerProductType === ProductType.LOAN)

                    offers.push({
                        key: response.providerKey,
                        offerMessage: offerMessage,
                        approvalAmount: response.approvedAmountCents,
                    })

                    if (hasSynchronyLoanPlans) {
                        const payMonthlyApprovedAmountCents = Math.max(
                            0,
                            ...paymentPlans
                                .filter(plan => plan.providerProductType === ProductType.LOAN)
                                .map(plan => plan.financedAmountCents || 0)
                        )
                        offers.push({
                            key: "paymonthly",
                            offerMessage: "Synchrony Pay Later Loan",
                            approvalAmount: payMonthlyApprovedAmountCents || response.approvedAmountCents,
                        })
                    }
                })
                return offers
            },
        },
    }
</script>
<style scoped lang="scss">
    .header-list-item {
        color: $grey-darken-2;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
    }
</style>
